import { CmsYourAppliancePage } from './cms/cms-your-appliance-page.interface';

export interface YourApplianceConfig {
  cmsData: CmsYourAppliancePage;
}
